module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Copyright Page",
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "CRT1"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page v. ",
      "epub:type": "pagebreak",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The characters and events in this book are fictitious. Any similarity to real persons, living or dead, is coincidental and not intended by the author.")])]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("© 2022, Text by Ken Kalfus")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("All rights reserved. Except for brief quotations in critical articles or reviews, no part of this book may be reproduced in any manner without prior written permission from the publisher: Milkweed Editions, 1011 Washington Avenue South, Suite 300, Minneapolis, Minnesota 55415.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("(800) 520-6455")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_c('a', {
    attrs: {
      "href": "http://milkweed.org",
      "target": "_blank"
    }
  }, [_vm._v("milkweed"), _c('wbr'), _vm._v(".org")])]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("Published 2022 by Milkweed Editions")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Printed in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Cover design and illustration by Mary Austin Speaker")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Cover photograph by Kramer O’Neill")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("22 23 24 25 26"), _c('span', {
    staticClass: "padd"
  }, [_vm._v("5 4 3 2 1")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_c('i', [_vm._v("First Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("Part of this novel appeared on the "), _c('i', [_vm._v("n + 1")]), _vm._v(" website, "), _c('a', {
    attrs: {
      "href": "http://nplusonemag.com",
      "target": "_blank"
    }
  }, [_vm._v("nplusonemag.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("Names: Kalfus, Ken, author.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Title: 2 a.m. in Little America : a novel / Ken Kalfus.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Description: First edition. | Minneapolis, Minnesota : Milkweed Editions, 2022.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Identifiers: LCCN 2021044847 (print) | LCCN 2021044848 (ebook) | ISBN 9781571311443 (hardcover ; acid-free paper) | ISBN 9781571317735 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Subjects: LCGFT: Novels. Classification: LCC PS3561.A416524 A613 2022 (print) | LCC PS3561.A416524 (ebook) | DDC 813/.54--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2021044847",
      "target": "_blank"
    }
  }, [_vm._v("https://"), _c('wbr'), _vm._v("lccn"), _c('wbr'), _vm._v(".loc"), _c('wbr'), _vm._v(".gov"), _c('wbr'), _vm._v("/2021044847")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2021044848",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2021044848")])]), _vm._v(" "), _c('p', {
    staticClass: "CRTF"
  }, [_vm._v("Milkweed Editions is committed to ecological stewardship. We strive to align our book production practices with this principle, and to reduce the impact of our operations in the environment. We are a member of the Green Press Initiative, a nonprofit coalition of publishers, manufacturers, and authors working to protect the world’s endangered forests and conserve natural resources. "), _c('i', [_vm._v("2 A.M. in Little America")]), _vm._v(" was printed on acid-free 100% postconsumer-waste paper by Friesens Corporation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0